/**
 * 搜索相关
 */
import URL from '../url.js'
import utils from '@/utils/utils.js'
import { get, post } from '../http'
import config from '@/config'

export const searchAllWords = (params, apiEndpoint = 'searchAllWords') => get(URL[apiEndpoint], params)
export const searchProductList = (data) => post(URL.searchProductList, data)
export const searchGuessyoulike = (data) => post(URL.guessyoulike, data)

export const searchNearByMdStore = (params) => get(URL.queryMdListByLocation, params)

// 搜索的默认词
export const defaultSearch = data => get(URL.defaultSearch, data, {
  baseURL: config.SHOST,
})
// 热门推荐
export const hotRecommend = data => get(URL.hotSearch, data, {
  baseURL: config.SHOST,
})

// 活动标签
export const getSelectBoxTagList = data => get(URL.getSelectBoxTagList, data, {
  baseURL: config.SHOST,
})

// 热搜榜
export const getHotSearchProductList = data => post(URL.topSearch, data, {
  baseURL: config.SHOST,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
})
// 关键词推荐
export const searchDropdown = data => get(URL.searchDropdown, data, {
  baseURL: config.SHOST,
})
// 关键词搜索商品列表
export const wdCommonSearchNew = data => get(URL.wdCommonSearchNew, data, {
  baseURL: config.HOST,
}, true)

// 获取skus直播状态等信息
export const getSkusLiveInfo = data => post(URL.getSkuLives, data, {
  baseURL: config.HOST,
}, true)

// 搜索店铺列表
export const searchStore = data => get(URL.getStoreInformation, data, {
  baseURL: config.SHOST,
}, true)
// 猜你喜欢
export const searchLoad = data => get(URL.getGuessYouLikeIt, data, {
  baseURL: config.SHOST,
}, false)
// 推荐店铺
export const associatedSearchStore = data => get(URL.associatedSearchStore, data, {
  baseURL: config.SHOST,
}, false)

// 最优门店
export const searchCateStore = data => post(URL.searchCateStore, data, {}, false)

export const getSceneList = data => post(URL.searchSceneList, data, {
  baseURL: config.DHOST,
})

export const searchMdStores = data => get(URL.searchMdStores, data, {}, false)

export const recommendSuitOrScene = data => post(URL.recommendSuitOrScene, data, {
  baseURL: config.DHOST,
  headers: {
    clientId: utils.getGuId()
  }
}, false)

export const hotSocialStore = data => get(URL.hotSocialStore, data, {}, false)

// 店铺搜索默认词
export const getStoreSearchWord = params => get(URL.storeSearchWord, params)
